import { Routes } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

export const Approutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      { path: '', redirectTo: '/authentication/login', pathMatch: 'full' },
      {
        path: 'announcement',
        loadChildren: './project/web/announcement/announcement.module#AnnouncementModule'
      },
      {
        path: 'resource',
        loadChildren: './project/web/resource/resource.module#ResourceModule'
      },
      {
        path: 'catalogue',
        loadChildren: './project/web/catalogue/catalogue.module#CatalogueModule'
      },
      {
        path: 'advertisement',
        loadChildren:
          './project/web/advertisement/advertisement.module#AdvertisementModule'
      },
      {
        path: 'activity',
        loadChildren: './project/web/activity/activity.module#ActivityModule'
      },
      {
        path: 'gallery',
        loadChildren: './project/web/gallery/gallery.module#GalleryModule'
      },
      {
        path: 'venue',
        loadChildren: './project/web/venue/venue.module#VenueModule'
      },
      {
        path: 'blog',
        loadChildren: './project/web/blog/blog.module#BlogModule'
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren:
          './authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/authentication/404'
  }
];
